// extracted by mini-css-extract-plugin
export default {"root":"LanguageSwitcher_root__L9n6F","option":"LanguageSwitcher_option__xF8nP","active":"LanguageSwitcher_active__wcvyc","divider":"LanguageSwitcher_divider__RuGgI"};